import {
    FAVOURITE_LIST_RECEIVE,
    FAVOURITE_LIST_ERROR,
    FAVOURITE_LIST_CHANGE_MODE,
    FAVOURITE_LIST_SET_LIST,
    FAVOURITE_LIST_SET_BANNER,
    FAVOURITE_LIST_SET_LOADING,
    ViewMode,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    mode: ViewMode.List,
    list: [],
    favouriteList: {},
    orderSheetUrl: '',
    errors: {},
    loading: false
};

export const favouritelist = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FAVOURITE_LIST_RECEIVE:
        case FAVOURITE_LIST_ERROR:
        case FAVOURITE_LIST_CHANGE_MODE:
        case FAVOURITE_LIST_SET_LIST:
        case FAVOURITE_LIST_SET_BANNER:
        case FAVOURITE_LIST_SET_LOADING:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case FAVOURITE_LIST_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
